import { render } from "./LoadingNews1.vue?vue&type=template&id=27ebd6b6&scoped=true"
import script from "./LoadingNews1.vue?vue&type=script&lang=js"
export * from "./LoadingNews1.vue?vue&type=script&lang=js"

import "../../assets/css/loading/index.css?vue&type=style&index=0&id=27ebd6b6&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27ebd6b6"]])

export default __exports__